import { useNoSleep } from '@/hooks/NoSleep';
import { useSubmitDrawing } from '@/hooks/PlayerSessionControlHooks';
import { useRef, useState } from 'react';
import AnimatedPlayerSharing from '../Animated/Backgrounds/AnimatedPlayerSharingBackground';
import Canvas, { LineProps } from '../Controls/Canvas';
import PlayerPrompt from './PlayerPrompt';

export default function PlayerCanvas() {
  // State
  const [drawing, setDrawing] = useState<LineProps[]>([]);
  const submitRef = useRef(false);

  // Hooks
  const { enableNoSleep } = useNoSleep();

  const submitDrawing = useSubmitDrawing();

  const onSubmit = async () => {
    if (submitRef.current) return;
    submitRef.current = true;

    enableNoSleep();

    await submitDrawing(JSON.stringify(drawing));

    setDrawing([]);
    submitRef.current = false;
  };

  return (
    <div className="fixed inset-0 min-h-screen min-w-screen h-full w-full flex items-center justify-center">
      <AnimatedPlayerSharing />

      <div className="relative max-w-lg w-full h-full">
        <PlayerPrompt />
        <div className="flex flex-col items-center justify-center">
          <div className="w-full h-[100% - 20rem] max-w-lg">
            <Canvas
              drawing={drawing}
              setDrawing={setDrawing}
              onSubmit={onSubmit}
              submissionEnabled={!submitRef.current}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
